
export enum MainUsers {
  MAINTENANCE = 'MAINTENANCE',
  MASTER = 'MASTER'
}

export function userNameUtils(userName: string | number): string | number {
  const master = $localize`Мастер-код`;
  const maintenance = $localize`Поддержка`;
  if (userName === MainUsers.MASTER) {
    return master;
  }
  if (userName === MainUsers.MAINTENANCE) {
    return maintenance;
  }

  return userName;
}
